module.exports = "/static/assets/57e8961a64163e11b723414129e75693.png";